var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.89286 15.4289C4.29518 15.4289 3 14.4291 3 12.9631C3 11.4972 4.29518 10.3088 5.89286 10.3088C6.0015 10.3088 6.10875 10.3143 6.21429 10.325V10.3088H6.25407C6.22781 10.1155 6.21429 9.91866 6.21429 9.71889C6.21429 7.11272 8.51682 5 11.3571 5C13.2805 5 14.9573 5.96881 15.8395 7.40361C16.0551 7.37452 16.2756 7.35945 16.5 7.35945C18.9853 7.35945 21 9.20808 21 11.4885C21 13.3657 19.6348 14.7967 17.7656 15.2684M11.858 19V12.2258M11.858 12.2258L8.90625 15.0196M11.858 12.2258L14.8125 15.0196",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIcon);
export default __webpack_public_path__ + "static/media/importIcon.3c11fbe97983ffabbda8cdb327f26a7c.svg";
export { ForwardRef as ReactComponent };